import { render, staticRenderFns } from "./GradientPicker.vue?vue&type=template&id=10564b40&"
import script from "./GradientPicker.vue?vue&type=script&lang=js&"
export * from "./GradientPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports